import React from 'react';
import autobind from 'autobind-decorator';

import {UnitNumberFieldEditor} from "../../../../Models/Core/FieldEditors";
import {UnitNumberFieldViewer} from "../../../../Models/Core/FieldViewers";

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";

@SurveyFormInputEnhance
export class SurveyFormInputNumber extends React.Component {

    @autobind
    change(value) {
        const { SurveyFormInput } = this.props;

        SurveyFormInput.Change((answer) => {
            const number = Number(value);

            if (value === "") {
                SurveyFormInput.MarkValidationStatusValid();
            } else if (isNaN(number) || (value.indexOf('e') > -1)) {
                SurveyFormInput.SetValidationStatusError("Invalid Number");
            } else {
                SurveyFormInput.MarkValidationStatusValid();
            }

            return { ...answer, valueNumeric: value };
        });
    }

    render() {
        const { SurveyFormInput, EditMode, Question: question } = this.props;

        const answer = SurveyFormInput.GetAnswer();
        const value = answer ? answer.valueNumeric: "";
        const fieldDef = {
            customData: {
                unitId: question?.unitId,
                maximumFractionDigits: question?.decimalPlaces ?? 6,
            }
        };

        if(!EditMode) {
            return <UnitNumberFieldViewer
                Value={value}
                FieldDef={fieldDef}
            />;
        }

        return <UnitNumberFieldEditor
            Value={value}
            FieldDef={fieldDef}
            OnUpdate={(x) => this.change(x)}
        />;
    }
}


